export default {
	apiKey: "AIzaSyCEf8iaAHGjXfnndlkk1hkmYgMonesJ-qg",
	authDomain: "ares-qa-app.firebaseapp.com",
	databaseURL: "https://ares-qa-app.firebaseio.com",
	projectId: "ares-qa-app",
	storageBucket: "ares-qa-app.appspot.com",
	messagingSenderId: "19685071341",
	appId: "1:19685071341:web:e97f7276a3d1a80d286fe4",
	measurementId: "G-4GLP8WZFPF"
};